var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDraw3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 98,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "url(#draw3_svg__paint0_linear_1_4)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.142 32.891l-13.726 4.742c-.27.093-.563.093-.832 0l-13.726-4.742c-1.164-.402-1.137-2.057.04-2.42l13.726-4.242c.245-.076.507-.076.752 0l13.727 4.242c1.176.363 1.203 2.018.04 2.42",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.142 27.059L25.416 31.8c-.27.093-.563.093-.832 0L10.858 27.06c-1.164-.402-1.137-2.057.04-2.42l13.726-4.242c.245-.076.507-.076.752 0l13.727 4.242c1.176.363 1.203 2.018.04 2.42",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.142 21.227l-13.726 4.742c-.27.093-.563.093-.832 0l-13.726-4.742c-1.164-.402-1.137-2.057.04-2.42l13.726-4.242c.245-.076.507-.076.752 0l13.727 4.242c1.176.363 1.203 2.018.04 2.42",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "draw3_svg__paint0_linear_1_4",
    x1: 24.268,
    y1: 75,
    x2: 74.268,
    y2: 26.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B129"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514,
    stopColor: "#F6570C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63C0C"
  })))));
}
export default SvgDraw3;